import { mapGetters, mapActions } from 'vuex';
import ArrowIcon from '@/components/ArwIcon/index.vue';
import ImageContainer from '@/components/ImageContainer/index.vue';

export default {
  name: 'ImageGalleryCarousel',
  data() {
    return {
      galleryListActive: false,
      loadedImagesCount: 0,
      useLargeImage: false,
    };
  },
  props: {
    imageList: {
      type: Array,
      required: true,
    },
    activeImageIndex: {
      type: Number,
      required: true,
    },
    updateActiveImageIndex: {
      type: Function,
      required: true,
    },
    isMultiImageGallery: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ArrowIcon,
    ImageContainer,
  },
  computed: {
    activeImage() {
      return (index) => index === this.activeImageIndex;
    },
    ...mapGetters({
      galleryLoaded: 'getGalleryLoaded',
      partNumber: 'getPartNumber',
    }),
  },
  mounted() {
    this.activateImageList();
  },
  beforeUpdate() {
    this.calculateImageSize();
  },
  methods: {
    // Use this when opening enhanced images, based on type
    openViewer(activeImage) {
      if (activeImage.type && activeImage.type === '360') {
        this.$router.push({
          name: 'ViewerPath',
          params: {
            ...this.$router.currentRoute.params,
            // Include the part number so the PID route also works
            partNumber: this.partNumber,
          },
          hash: this.$router.currentRoute.hash,
        });
      }
    },
    set360GaAttr(activeImage) {
      if (activeImage.type && activeImage.type === '360') {
        return 'Product Page, Image Gallery, 360 Gallery Image';
      }
      return '';
    },
    setArrowGaAttr(direction) {
      return `EMS - Gallery Arrow, click, ${direction}`;
    },
    activateImageList() {
      setTimeout(() => {
        // We want the component to finish rendering on the page
        // before setting this so the transition shows up
        this.galleryListActive = true;
      }, 0);
    },
    calculateImageSize() {
      if (!this.imageList || !this.imageList.length) {
        return null;
      }
      const img = new Image();
      img.src = this.imageList[0].imageSrc;
      img.onload = () => {
        this.useLargeImage = img.naturalWidth >= 600;
      };
      return img;
    },
    handleScroll(event) {
      const id = Math.round(
        event.srcElement.scrollLeft / event.srcElement.firstChild.clientWidth,
      );
      if (id <= this.imageList.length) {
        this.updateActiveImageIndex(id);
      }
    },
    clickLeft() {
      const { length } = this.imageList;
      if (this.activeImageIndex - 1 >= 0) {
        this.updateActiveImageIndex(this.activeImageIndex - 1);
      } else {
        this.updateActiveImageIndex(length - 1);
      }
    },
    clickRight() {
      const { length } = this.imageList;
      if (this.activeImageIndex + 1 < length) {
        this.updateActiveImageIndex(this.activeImageIndex + 1);
      } else {
        this.updateActiveImageIndex(0);
      }
    },
    imageLoaded() {
      // This event is triggered after each image loads
      this.loadedImagesCount += 1;

      // When all are done we set the store flag
      if (this.loadedImagesCount === this.imageList.length) {
        this.setGalleryLoaded(true);
      }
    },
    ...mapActions([
      'setGalleryLoaded',
    ]),
  },
};
